const billings = {
  ext: 'ext',
  int: 'int',
};

export default billings;
